module.exports = __webpack_public_path__ + "img/t-24747-003.6fd89949.jpg";